import AddAttachmentDataProviderResponse from 'owa-service/lib/contract/AddAttachmentDataProviderResponse';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import addAttachmentDataProviderRequest from 'owa-service/lib/factory/addAttachmentDataProviderRequest';
import addNewAttachmentDataProviderOperation from 'owa-service/lib/operation/addNewAttachmentDataProviderOperation';

export default function addFileProvider(
    providerType: AttachmentDataProviderType,
    authCode: string,
    redirectUrl: string,
    updateProvider: boolean = false
): Promise<AddAttachmentDataProviderResponse> {
    const request = addAttachmentDataProviderRequest({
        ProviderType: providerType,
        DataProviderAuthCode: authCode,
        RedirectUrl: redirectUrl,
        IsUpdate: updateProvider,
    });

    return addNewAttachmentDataProviderOperation(request);
}
